import { render, staticRenderFns } from "./DoubleElimination.vue?vue&type=template&id=e5355d0e&scoped=true&"
import script from "./DoubleElimination.vue?vue&type=script&lang=js&"
export * from "./DoubleElimination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5355d0e",
  null
  
)

export default component.exports